module.exports = __webpack_public_path__ + "img/24_9.ef0c7579.png";